module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/huEKd7/images/e9781439640883_cover.jpg?1684514754173",
      "alt": "This image is the cover for the book Mansfield, Then and Now"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Mansfield, Then and Now\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Mansfield began in 1808 when its public square was carved out of a wilderness inhabited only by Wyandots, wild animals, and an itinerant nurseryman named Johnny Appleseed. Throughout the 200 years since then, the character and appearance of the city has transformed many times as new generations remade it into their home. Driving around Mansfield today, there is enough remaining of historical times to compare with old photographs in order to make the past come alive.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Timothy Brian McKee, Jeff Sprang\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Timothy Brian McKee documents various eras of Mansfield�s changing face with rare photographs from collections of the Mansfield/Richland County Public Library, the Richland County Historical Society, and the Richland County chapter of the Ohio Genealogical Society. A historian, filmmaker, and artist, McKee is also the author of the Postcard History Series title Mansfield.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0